var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfettiStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 120",
    width: "100%",
    height: 120,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .p { transform-origin: center; animation: fall 3.6s linear infinite; opacity:.9 }\n    .p2 { animation-delay: .4s } .p3 { animation-delay: .8s } .p4 { animation-delay: 1.2s }\n    .p5 { animation-delay: 1.6s } .p6 { animation-delay: 2s } .p7{animation-delay:2.4s}\n    @keyframes fall {\n      0%   { transform: translateY(-18px) rotate(0deg);   opacity:.0 }\n      10%  { opacity:1 }\n      70%  { transform: translateY(96px) rotate(180deg); }\n      100% { transform: translateY(120px) rotate(270deg); opacity:.0 }\n    }\n    @media (prefers-reduced-motion: reduce) { .p { animation: none } }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: 10,
    y: 0,
    width: 6,
    height: 8,
    fill: "var(--color-primary,#7C4DFF)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "p2",
    x: 28,
    y: 0,
    width: 6,
    height: 10,
    fill: "var(--color-accent,#37E5FF)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "p3",
    x: 46,
    y: 0,
    width: 4,
    height: 8,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "p4",
    x: 64,
    y: 0,
    width: 5,
    height: 10,
    fill: "var(--color-accent,#37E5FF)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "p5",
    x: 82,
    y: 0,
    width: 6,
    height: 8,
    fill: "var(--color-primary,#7C4DFF)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "p6",
    x: 100,
    y: 0,
    width: 4,
    height: 9,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "p7",
    x: 118,
    y: 0,
    width: 5,
    height: 8,
    fill: "var(--color-accent,#37E5FF)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: 136,
    y: 0,
    width: 6,
    height: 10,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "p2",
    x: 154,
    y: 0,
    width: 4,
    height: 8,
    fill: "var(--color-primary,#7C4DFF)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "p3",
    x: 172,
    y: 0,
    width: 6,
    height: 9,
    fill: "var(--color-accent,#37E5FF)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "p4",
    x: 190,
    y: 0,
    width: 5,
    height: 8,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "p5",
    x: 208,
    y: 0,
    width: 4,
    height: 10,
    fill: "var(--color-primary,#7C4DFF)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiStream);
export default __webpack_public_path__ + "static/media/confetti-stream.8b2172f43cf99689fac41d3acb05ec80.svg";
export { ForwardRef as ReactComponent };